(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VanillaScrollspy"] = factory();
	else
		root["VanillaScrollspy"] = factory();
})(window, function() {
	return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
			/******/
			/******/ 		// Check if module is in cache
			/******/ 		if(installedModules[moduleId]) {
				/******/ 			return installedModules[moduleId].exports;
				/******/ 		}
			/******/ 		// Create a new module (and put it into the cache)
			/******/ 		var module = installedModules[moduleId] = {
				/******/ 			i: moduleId,
				/******/ 			l: false,
				/******/ 			exports: {}
				/******/ 		};
			/******/
			/******/ 		// Execute the module function
			/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
			/******/
			/******/ 		// Flag the module as loaded
			/******/ 		module.l = true;
			/******/
			/******/ 		// Return the exports of the module
			/******/ 		return module.exports;
			/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// define getter function for harmony exports
		/******/ 	__webpack_require__.d = function(exports, name, getter) {
			/******/ 		if(!__webpack_require__.o(exports, name)) {
				/******/ 			Object.defineProperty(exports, name, {
					/******/ 				configurable: false,
					/******/ 				enumerable: true,
					/******/ 				get: getter
					/******/ 			});
				/******/ 		}
			/******/ 	};
		/******/
		/******/ 	// define __esModule on exports
		/******/ 	__webpack_require__.r = function(exports) {
			/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
			/******/ 	};
		/******/
		/******/ 	// getDefaultExport function for compatibility with non-harmony modules
		/******/ 	__webpack_require__.n = function(module) {
			/******/ 		var getter = module && module.__esModule ?
				/******/ 			function getDefault() { return module['default']; } :
				/******/ 			function getModuleExports() { return module; };
			/******/ 		__webpack_require__.d(getter, 'a', getter);
			/******/ 		return getter;
			/******/ 	};
		/******/
		/******/ 	// Object.prototype.hasOwnProperty.call
		/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(__webpack_require__.s = "./index.js");
		/******/ })
	/************************************************************************/
	/******/ ({

		/***/ "./index.js":
		/*!******************!*\
		  !*** ./index.js ***!
		  \******************/
		/*! no static exports found */
		/***/ (function(module, exports, __webpack_require__) {

			"use strict";


			module.exports = __webpack_require__(/*! ./src/index */ "./src/index.js").default;

			/***/ }),

		/***/ "./src/index.js":
		/*!**********************!*\
		  !*** ./src/index.js ***!
		  \**********************/
		/*! no static exports found */
		/***/ (function(module, exports, __webpack_require__) {

			"use strict";


			Object.defineProperty(exports, "__esModule", {
				value: true
			});

			var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

			var fncAnimation = function fncAnimation(callback) {
				window.setTimeout(callback, 1000 / 60);
				return callback;
			};

			window.requestAnimFrame = function () {
				return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || fncAnimation;
			}();

			var VanillaScrollspy = function () {
				function VanillaScrollspy(menu) {
					var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
					var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'easeOutSine';

					_classCallCheck(this, VanillaScrollspy);

					this.menu = menu;
					this.speed = speed;
					this.easing = easing;
				}

				_createClass(VanillaScrollspy, [{
					key: 'scrollToY',
					value: function scrollToY() {
						var _this = this;

						var targetY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

						var scrollTargetY = targetY;
						var scrollY = window.scrollY || document.documentElement.scrollTop;
						var currentTime = 0;
						var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / this.speed, 0.8));

						var easingEquations = {
							easeOutSine: function easeOutSine(pos) {
								return Math.sin(pos * (Math.PI / 2));
							},
							easeInOutSine: function easeInOutSine(pos) {
								return -0.5 * (Math.cos(Math.PI * pos) - 1);
							},
							easeInOutQuint: function easeInOutQuint(pos) {
								/* eslint-disable-next-line */
								if ((pos /= 0.5) < 1) {
									return 0.5 * Math.pow(pos, 5);
								}
								return 0.5 * (Math.pow(pos - 2, 5) + 2);
							}
						};

						var tick = function tick() {
							currentTime += 1 / 60;
							var p = currentTime / time;
							var t = easingEquations[_this.easing](p);

							if (p < 1) {
								window.requestAnimFrame(tick);
								window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
							} else {
								window.scrollTo(0, scrollTargetY);
							}
						};

						tick();
					}
				}, {
					key: 'menuControl',
					value: function menuControl() {
						var i = void 0;
						var currLink = void 0;
						var refElement = void 0;
						var links = this.menu.querySelectorAll('a.same-page-nav__link[href^="#"]');
						var scrollPos = window.scrollY || document.documentElement.scrollTop;

						for (i = 0; i < links.length; i += 1) {
							currLink = links[i];
							refElement = document.querySelector(currLink.getAttribute('href'));

							if ((refElement.offsetTop - document.getElementById('angular-nav').offsetHeight) <= scrollPos && (refElement.offsetTop - document.getElementById('angular-nav').offsetHeight) + refElement.clientHeight > scrollPos) {
								currLink.parentNode.classList.add('same-page-nav__item--selected');
							} else {
								currLink.parentNode.classList.remove('same-page-nav__item--selected');
							}
						}
					}
				}, {
					key: 'animated',
					value: function animated() {
						var self = this;
						function control(e) {
							e.preventDefault();
							var target = document.querySelector(this.hash);
							self.scrollToY(target.offsetTop);
						}

						var i = void 0;
						var link = void 0;
						var links = this.menu.querySelectorAll('a[href^="#"]');

						for (i = 0; i < links.length; i += 1) {
							link = links[i];
							link.addEventListener('click', control);
						}
					}
				}, {
					key: 'init',
					value: function init() {
						var _this2 = this;

						//this.animated();
						document.addEventListener('scroll', function () {
							_this2.menuControl();
						});
					}
				}]);

				return VanillaScrollspy;
			}();

			exports.default = VanillaScrollspy;

			/***/ })

		/******/ });
});
//# sourceMappingURL=vanillajs-scrollspy.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/Widgets/HanScrollSpy.js
// module id = ./src/js/Widgets/HanScrollSpy.js
// module chunks = main